import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOpt"><Path d="M3.5 4.5H8L16 19.5H20.5M20.5 4.5H16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconOpt;
